export default __webpack_public_path__ + "media/images/cta-bg-5abbca00a0f94a31624f529bbbe75446.jpg";